import { TFunction } from 'i18next';
import TaskDTO from 'models/dto/tasks/taskDTO';
import ReportRequestDTO from './ReportRequestDTO';

export class TaskWorkableTypeLabelsDTO {
  single: string;

  recurring: string;

  legacyRecurring: string;

  event: string;

  subtask: string;

  approval: string;

  constructor() {
    this.single = '';
    this.recurring = '';
    this.legacyRecurring = '';
    this.event = '';
    this.subtask = '';
    this.approval = '';
  }
}

export class ReportRequest24DTO extends ReportRequestDTO {
  taskColumns: string[];

  taskColumnsExcel: string[];

  chartSeriesLabel: string;

  taskTypeLabels: TaskWorkableTypeLabelsDTO;

  tasks: TaskDTO[];

  constructor(report: ReportRequestDTO, t?: TFunction<string[]>) {
    super(report);
    this.taskColumns = [];
    this.taskColumnsExcel = [];
    this.chartSeriesLabel = '';
    this.taskTypeLabels = new TaskWorkableTypeLabelsDTO();
    this.tasks = [];

    if (t) {
      this.taskColumns = [
        t('translation:General.EntityType.Task'),
        t('task:Description.Label'),
        t('tags:General.Name'),
        t('task:Assignment.Label'),
        t('task:Status.Label'),
        t('task:Start.Label'),
        t('task:Deadline.Label'),
        t('task:Pivot.Checklist'),
      ];

      this.taskColumnsExcel = [t('tasks:TabAllTasks.Fields.Type'), t('tasks:Reports.IsPartOfEvent')];
      this.chartSeriesLabel = t('tasks:Reports.TaskCount');

      this.taskTypeLabels.single = t('tasks:WorkableTypes.Single');
      this.taskTypeLabels.recurring = t('tasks:WorkableTypes.Recurring');
      this.taskTypeLabels.legacyRecurring = t('tasks:WorkableTypes.LegacyRecurring');
      this.taskTypeLabels.event = t('tasks:WorkableTypes.Event');
      this.taskTypeLabels.subtask = t('tasks:WorkableTypes.Subtask');
      this.taskTypeLabels.approval = t('tasks:WorkableTypes.Approval');
    }
  }

  clone(): ReportRequest24DTO {
    const output = new ReportRequest24DTO(this);
    output.tasks = [...this.tasks];
    output.taskColumns = [...this.taskColumns];
    output.taskColumnsExcel = [...this.taskColumnsExcel];
    output.chartSeriesLabel = this.chartSeriesLabel;
    output.taskTypeLabels = { ...this.taskTypeLabels };

    return output;
  }
}
